import React, { createContext, useContext } from 'react';

import type { ProfilecardTriggerPosition } from '@atlaskit/profilecard/types';

type ReportingLinesContextType = {
	product?: string;
	WrappedWithProfilecard?: React.ComponentType<{
		children: React.ReactElement;
		userId: string;
		position?: ProfilecardTriggerPosition;
	}>;
};

const ReportingLinesContext = createContext<ReportingLinesContextType>({});

export const ReportingLinesProvider = ({
	children,
	product,
	WrappedWithProfilecard,
}: ReportingLinesContextType & { children: React.ReactElement }): React.JSX.Element => {
	return (
		<ReportingLinesContext.Provider value={{ product, WrappedWithProfilecard }}>
			{children}
		</ReportingLinesContext.Provider>
	);
};

export const useReportingLinesContext = () => useContext(ReportingLinesContext);
